export const TagKeysAndValues: Record<string, string[]> = {
  Name: ["Cone", "Cube", "Sphere", "Model"],
  Room: [
    "Bath_1",
    "Bath_2",
    "Bath_2_Closet",
    "Bath_3",
    "Bath_4",
    "Bath_5",
    "Bath_Half",
    "Bed_1",
    "Bed_2",
    "Bed_2_Closet",
    "Bed_3",
    "Bed_3_Closet",
    "Bed_4",
    "Bed_4_Closet",
    "Bed_5",
    "Bed_5_Closet",
    "Bed_5_FH",
    "Bed_5_International",
    "Butlers_Pantry",
    "Dining",
    "Dining_Room",
    "Entry_Closet",
    "Entry_Everyday",
    "Everyday_Entry",
    "Flex_Room",
    "Foyer",
    "Foyer_2nd_Flr",
    "Garage",
    "Garage_3_Car_Side",
    "Garage_Equip",
    "Great_Room",
    "Great_Room_2nd_Flr",
    "Hallway",
    "Hallway_Closet",
    "Kitchen",
    "Laundry",
    "Office",
    "Owner_Bath_Closet",
    "Owner_Bath_WC",
    "Owner_WIC",
    "Pantry",
    "Powder",
    "Prep_Kitchen",
    "Retreat",
    "Staircase",
    "Stairs",
    "Stairs_Closet",
  ],
  Room_Item: [
    "Asphalt_Roof",
    "Asphalt_Roof_Ridge",
    "Backsplash",
    "Baseboard",
    "Board_&_Batten",
    "Brick",
    "Brick_Trim",
    "Cabinet",
    "Cedar",
    "Ceiling",
    "Countertop",
    "Fascia",
    "Feature_Shower_Wall",
    "Fireplace_Wall_1",
    "Fireplace_Wall_2",
    "Fitout",
    "Floor",
    "Front_Door",
    "Front_Lap_Siding",
    "Garage_Door",
    "Island_Cabinet",
    "Island_Countertop",
    "Lower_Cabinet",
    "Metal_Awning",
    "Metal_Roof",
    "Shower_Floor",
    "Shower_Wall",
    "Tall_Cabinet",
    "Tapware",
    "Treads",
    "Trim",
    "Upper_Cabinet",
    "Wall",
    "Window_Frame",
    "Sink",

    // new values in legacy in rhinewood
    "Stone",
    "Stone_Sill",
    "Tiled_Floor",
    "Timber_Floor",
    "Carpet_Floor",
    "Casework",
    // end
  ],
  Room_Type: ["Standard", "Tall"],
  Home_Level: ["1stFlr", "2ndFlr"],
  Location: ["Int", "Half", "Ext"],
  Floor_Layout: ["Included", "Alternate"],
  Ceiling_Type: ["Flat", "Trayed", "Eggcrate", "Raked"],
  Ceiling_Height: ["Standard", "Tall"],
  Railing_Type: ["Included", "Iron", "Wood"],
  Exterior_Item: [
    "Siding_Double",
    "Siding_Designer",
    "Trim",
    "BoardBatten",
    "Shutter",
    "Shake",
    "Stucco",
  ],
  /* begin in rhinewood home */
  Home_Option: [
    "Prep_Kitchen",
    "Standard_Kitchen",
    "Alternate_Owner_Bath",
    "Standard_Owner_Bath",
    "Standard",
  ],
  Kitchen_Option: ["Prep_Kitchen", "Standard_Kitchen"],
  Owner_Bath_Option: ["Alternate_Owner_Bath", "Standard_Owner_Bath"],
  Elevation: ["International", "Farmhouse"],

  Theme: [],
  Facade: [],
  Option_1_Group: [],
  Option_1_Value: [],
  /* end in rhinewood home */
};

export const FreeformValueKeys: string[] = [
  "Theme",
  "Facade",
  "Option_1_Group",
  "Option_1_Value",
];
